import React from 'react';

const ConfirmField = ({ value }) => (
  <div>
    <label className='ticket_confirm_field body-1'>{value}</label>
  </div>
);

export default ConfirmField;
